<div class="dialog-wrapper">
  <div class="dialog-header">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="52.847"
      viewBox="0 0 60 52.847"
    >
      <path
        id="np_attention_2923438_000000"
        d="M61.341,48.8,39.432,12.113a8.119,8.119,0,0,0-13.891,0L3.633,48.8a8.121,8.121,0,0,0,6.946,12.248H54.4a7.894,7.894,0,0,0,7.01-4.1,8,8,0,0,0-.064-8.144ZM32.487,52.461A3.409,3.409,0,1,1,35.9,49.052,3.394,3.394,0,0,1,32.487,52.461ZM36.15,26.509l-1.2,14.081A2.462,2.462,0,0,1,32.3,42.8a2.43,2.43,0,0,1-2.21-2.21l-1.2-14.081a3.676,3.676,0,0,1,7.325-.631,2.041,2.041,0,0,0-.067.631Z"
        transform="translate(-2.489 -8.199)"
        fill="#004A63"
      />
    </svg>
  </div>

  <ng-container *ngIf="!_commonService.isNetworkDown; else offline">
    <div class="dialog-body">
      <h4>Online</h4>
      <p class="message">Your device is back to online</p>
    </div>
  </ng-container>
  <ng-template #offline>
    <div class="dialog-body">
      <h4>Offline</h4>
      <p class="message">Your device is offline</p>
    </div>
  </ng-template>
  <div class="dialog-footer" *ngIf="!_commonService.isNetworkDown">
    <button
      type="button"
      class="button-common button40"
      clickable
      (click)="close()"
    >
      <span>Continue</span>
    </button>
  </div>
</div>
